'use client';

import { Card, CardContent, CardHeader, Skeleton } from '@repo/ui';
import type { JSX } from 'react';

export function PasskeyCardSkeleton(): JSX.Element {
  return (
    <Card>
      <CardHeader>
        <Skeleton className="h-6 w-24" />
        <Skeleton className="h-4 w-48" />
      </CardHeader>
      <CardContent>
        <Skeleton className="h-10 w-32" />
      </CardContent>
    </Card>
  );
}
